import { render, staticRenderFns } from "./global-footer.vue?vue&type=template&id=8cbef90c&scoped=true&"
import script from "./global-footer.vue?vue&type=script&lang=js&"
export * from "./global-footer.vue?vue&type=script&lang=js&"
import style0 from "./global-footer.vue?vue&type=style&index=0&id=8cbef90c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cbef90c",
  null
  
)

export default component.exports